import { CHAPTERS } from 'variables/constants';
import { getItemTitleKey } from '@insights-ltd/design-library/utils';

const errorMessageCallback = (item: string) =>
  `Chapter '${item}' not recognised`;

export const getChapterKey = (chapter: string) =>
  getItemTitleKey(CHAPTERS, chapter, errorMessageCallback);
